import React from "react";
import "./utilities.css";
export default function Banner({ img, title }) {
  return (
    <div
      id="banner"
      className="my-5"
      style={{
        background: `url(${img})`,
      }}
    >
      <span className="darker"></span>
      <h1 className="text-light fw-bold z-3 text-center">{title}</h1>
    </div>
  );
}
